module.exports = __webpack_public_path__ + "img/Stemness-LICA_GSE146409.ad9abe87.png";